var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowLeft = function SvgArrowLeft(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41666 12.5522C8.08332 11.7824 7.41666 11.3975 7.41666 10.8202C7.41666 10.2428 8.08332 9.85792 9.41666 9.08812L11.6667 7.78909C13 7.01929 13.6667 6.63439 14.1667 6.92306C14.6667 7.21174 14.6667 7.98154 14.6667 9.52114V12.1192C14.6667 13.6588 14.6667 14.4286 14.1667 14.7173C13.6667 15.006 13 14.6211 11.6667 13.8513L9.41666 12.5522Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };